declare const IS_DEV_BUILD: boolean; // The value is supplied by Webpack during the build
declare const VERSION: string; // The value is supplied by Webpack during the build
import * as Sentry from '@sentry/browser';
// import { Integrations } from '@sentry/tracing';
// import { RewriteFrames } from '@sentry/integrations';

if (!IS_DEV_BUILD) {

  Sentry.init({
    dsn: 'https://68dc5a7baeed492e81f53b29c14868e7@o460993.ingest.sentry.io/5462155',
    release: `v-${VERSION}`,
    // integrations: [new Integrations.BrowserTracing()],
    // tracesSampleRate: 0.25,
    // debug: true,
    // beforeSend(event) {
    //  alert('Event!');
    //  console.log(event);
    //  return event;
    // },
  });

} else {

  // Sentry.init({
  //  dsn: 'https://a14734e2f34e483fb65ac3c289bec28e@o460993.ingest.sentry.io/5462176',
  //  release: `v-${VERSION}`,
  //  integrations: [new Integrations.BrowserTracing()],
  //  tracesSampleRate: 1.0,
  // });
}

export class Cookies {

  private resizeTask: any = null;
  private resizeListener: any = null;
  private contentHeight: number = 0;
  private customising: boolean = false;

  constructor() {
    console.log('Cookies invoked!');
  }

  setupCustomise() {
    const link = document.querySelector('.cookie-customise');

    if (link) {
      link.addEventListener('click', this.showCookieOptionsIfClickLink.bind(this));
    }

  }

  setupClose() {
    const link = document.querySelector('.cookieoptions__close');

    if (link) {
      link.addEventListener('click', this.closeCookieOptionsIfClickLink.bind(this));
    }

  }

  setupForm() {
    // submit button animation if form input valid
    const cookieForm = document.querySelector('#cookieForm1');
    const cookieForm2 = document.querySelector('#cookieForm2');
    if (cookieForm) {
      cookieForm.addEventListener('submit', () => this.onSubmit(cookieForm));
    }
    if (cookieForm2) {
      cookieForm2.addEventListener('submit', () => this.onSubmit(cookieForm2));
    }
  }

  onSubmit(form: any) {
    this.sendPostMessage(true);
    const parent = window.parent.document;
    parent.body.classList.remove('consent-open');
  }

  showCookieOptionsIfClickLink(event: any) {

    if (event) {
      const theevent = event || window.event;
      const { target: eventtarget } = theevent;
    }

    const consent = document.querySelector('.cookie-consent');
    if (consent) {
      this.customising = true;
      consent.classList.add('cookie-consent--customising');
      const parent = window.parent.document;
      parent.body.classList.add('consent-open');
      this.sendPostMessage(false, true);
    }

  }

  closeCookieOptionsIfClickLink(event: any) {

    if (event) {
      const theevent = event || window.event;
      const { target: eventtarget } = theevent;
    }

    const consent = document.querySelector('.cookie-consent');
    if (consent) {
      this.customising = false;
      consent.classList.remove('cookie-consent--customising');
      const parent = window.parent.document;
      parent.body.classList.remove('consent-open');
      this.sendPostMessage(false, false);
    }

  }

  setupResizeListener() {

    this.resizeListener = () => {

      if (this.resizeTask !== null) {
        clearTimeout(this.resizeTask);
      }

      this.resizeTask = setTimeout(
        () => {
          this.resizeTask = null;
          console.log('Resize cFrame!');
          this.sendPostMessage(false, this.customising);
        },
        delay);

    };

    const delay = 100;
    window.addEventListener('resize', this.resizeListener.bind(this));

  }

  sendPostMessage(hide: boolean, customising?: boolean) {

    const container: HTMLElement | null = document.getElementById('cookieContainer');
    console.log(`contentHeight: ${this.contentHeight}. offsetHeight: ${container?.offsetHeight}`);
    // if (container && this.contentHeight !== container.offsetHeight) {
    if (container) {
      this.contentHeight = container.offsetHeight;
      window.parent.postMessage(
        {
          customising,
          cFrameHeight: hide ? 0 : this.contentHeight,
        },
        '*');
      console.log('Message sent');
      console.log(this.contentHeight);
    }
  }

}

const cookiesJs = new Cookies();
cookiesJs.setupResizeListener();
cookiesJs.setupCustomise();
cookiesJs.setupClose();
cookiesJs.setupForm();

window.onload = () => {
  setTimeout(
    () => {
      cookiesJs.sendPostMessage(false);
    },
    250,
  );
};
